import React from "react";
import { ChevronLeftIcon } from "@vector-im/compound-design-tokens/assets/web/icons";

import { _t } from "../../../../languageHandler";
import AccessibleButton from "../../elements/AccessibleButton";
import { type PollHistoryFilter } from "./types";

interface Props {
    filter: PollHistoryFilter;
    onNavigateBack: () => void;
}

export const PollDetailHeader: React.FC<Props> = ({ filter, onNavigateBack }) => {
    return (
        <AccessibleButton kind="content_inline" onClick={onNavigateBack} className="mx_PollDetailHeader">
            <ChevronLeftIcon className="mx_PollDetailHeader_icon" />
            {filter === "ACTIVE" ? _t("right_panel.poll.active_heading") : _t("right_panel.poll.past_heading")}
        </AccessibleButton>
    );
};
